<template>
  <div
    class="ps-modal-helper ps-absolute ps-top-0 ps-left-0 ps-w-full ps-h-12 md:ps-h-16 lg:ps-h-24 ps-flex ps-items-center ps-justify-center"
  >
    <div class="ps-h-8 w-full ps-flex ps-items-center ps-justify-center">
      <a
        href="#"
        class="ps--mr-4 ps-bg-brand-brown-400 hover:ps-bg-brand-brown-600 ps-w-12 md:ps-w-16 lg:ps-w-20 ps-h-12 md:ps-h-16 lg:ps-h-20 ps-rounded-full ps-bubble ps-bubble-delay-300 ps-shadow-xl ps-pointer-events-auto"
        target="_blank"
        @click.prevent="showHelp"
      >
        <span
          class="ps-w-full ps-h-full ps-flex ps-items-center ps-justify-center ps-text-white"
        >
          Help
        </span>
      </a>
      <div
        class="ps-bg-brand-orange ps-rounded-full ps-w-32 md:ps-w-40 lg:ps-w-48 ps-h-32 md:ps-h-40 lg:ps-h-48 ps-flex ps-items-center ps-justify-center ps-shadow-lg ps-text-white"
      >
        <div class="ps-w-3/5">
          <svg-icon name="picnic-logo" width="100%" height="auto" />
        </div>
      </div>
      <button-icon
        v-if="isModeSite"
        class="ps-ml-2 ps-flex ps-items-center ps-justify-end ps-bg-brand-brown-800 ps-rounded-full ps-pointer-events-auto ps-shadow-lg"
        color="white"
        :size="10"
        @button-click="closeModal"
      >
        <svg-icon name="close" width="15" height="auto" color="#ffffff" />
      </button-icon>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from '@picnic-software/vuex'
import ButtonIcon from '@/components/buttons/ButtonIcon'
import { ROUTE_CONTROLS, ROUTE_HELP } from '@/common/constants'

export default {
  name: 'ModalHelper',
  props: {
    msg: String
  },
  components: {
    ButtonIcon
  },
  computed: {
    ...mapGetters({
      isModeSite: 'app/isModeSite'
    })
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to'
    }),
    closeModal() {
      this.routerTo(ROUTE_CONTROLS)
    },
    showHelp() {
      this.routerTo(ROUTE_HELP)
    }
  }
}
</script>

<style lang="postcss" scoped>
.ps-modal-helper {
  transition: all 350ms ease;
  will-change: transform;
  transform: translateY(-425%);
  &.is-active {
    transition-delay: 400ms;
    transform: translateY(0);
  }
}
</style>
